import React from "react";
import { Box, Container, Typography } from "@mui/material";
import BlogCards from "../components/BlogsSections/BlogCards";
import banner1 from "../assets/Banner/WebBanner/b2.png";
import HeroSection from "../components/HeroSection";
import logo from "../assets/images/About/about-logo.png";
import initialBlogs from "../layout/blogCards/BlogsData";

const Blogs: React.FC = () => (
  <>
    <HeroSection
      bannerImage={banner1}
      heading="Global Think Tank"
      description="At Across Assist, we are dedicated to leading the way in industry innovation and thought leadership. Our Global Think Tank is at the heart of this mission. Comprised of experts and visionaries from the assurance industry, our think tank is a vibrant forum for exploring and developing groundbreaking ideas that set new standards for quality and innovation."
      image={logo}
      gradientBg="linear-gradient(268.53deg, #1363DF 28.18%, #000000 124.21%)"
      gradientOpacity={0.9}
    />

    <Box sx={ReImagineStyles.rootTwo}>
      <Container maxWidth="lg" disableGutters className="max-w-screen-xl">
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            sx={{
              width: 2.5,
              height: { xs: 50, md: 70 },
              background: "linear-gradient(45deg, #cfd8dc, #cfd8dc)",
            }}
          />
        </Box>

        <Box sx={{ textAlign: "center", my: 2 }}>
          <Typography
            variant="h6"
            sx={{
              fontFamily: '"Poppins", serif',
              fontSize: "1.2rem",
              fontWeight: "400",
              color: "#0B2347",
              opacity: 1,
              animation:
                "fadeInTextBlogs 0.8s 0.3s cubic-bezier(0.23, 1, 0.32, 1) forwards",
              textAlign: "center",
            }}
          >
            At Across Assist, we are dedicated to leading the way in industry
            innovation and thought leadership. Our Global Think Tank is at the
            heart of this mission. Comprised of experts and visionaries from the
            assurance industry, our think tank is a vibrant forum for exploring
            and developing groundbreaking ideas that set new standards for
            quality and innovation.
          </Typography>
        </Box>

        <Box mb={2} sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            sx={{
              width: 2.5,
              height: { xs: 50, md: 70 },
              background: "linear-gradient(45deg, #cfd8dc, #cfd8dc)",
            }}
          />
        </Box>

        <div className="max-w-screen-xl w-full px-8 py-12">
          <Typography
            variant="h4"
            sx={{
              fontFamily: '"Poppins", serif',
              fontSize: "2rem",
              fontWeight: "bold",
              color: "#000000",
              textAlign: "center",
              opacity: 0,
              animation:
                "fadeInTextBlogs 0.8s 1.1s cubic-bezier(0.23, 1, 0.32, 1) forwards",
            }}
          >
            Explore : Featured Content
          </Typography>

          <Box
            sx={{
              marginTop: 3,
              marginBottom: 4,
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
                xl: "repeat(3, 1fr)",
              },
              gap: 2,
              justifyItems: "stretch",
            }}
          >
            {initialBlogs.map((item) => (
              <Box key={item.id}>
                <BlogCards
                  blogId={item.id}
                  blogTitle={item.blogTitle}
                  blogImage={item.blogImage}
                  blogHeading={item.blogHeading}
                  blogDescription={item.blogDescription}
                  blogCreatedDate={item.blogCreatedDate}
                />
              </Box>
            ))}
          </Box>
        </div>
      </Container>
    </Box>
  </>
);

export default Blogs;

const ReImagineStyles = {
  root: {
    textAlign: "center",
    padding: "0 0 30px 0px",
    marginTop: "-1.3rem",
  },
  rootTwo: {
    textAlign: "center",
    padding: "30px 30px",
  },
};
